import styled from "@emotion/styled"
import { css } from '@emotion/react'

export const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 14px;
  border: 1px dashed currentColor;
  outline-style: solid;
  outline-width: 1px;
  outline-offset: -5px;
  outline-color: currentColor;

  & > svg {
    width: 20px;
    height: 20px;
  }
`
